<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="promotionInputTypes"
    item-value="id"
    item-text="description"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "PromotionInputTypeField",
  props: {
    value: Object
  },
  data: () => ({
    promotionInputTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.get("/api/types/promotionInputTypes").then(({ data }) => {
      this.promotionInputTypes = data;
    });
  }
};
</script>
